/**
 * Love Links Copy — Canonical Source of Truth
 * ============================================
 * 
 * All Love Links UI copy should import from here.
 * DO NOT hardcode Love Links language elsewhere.
 * 
 * Tone Guardrails:
 * - No use of the word "commission"
 * - No earnings promises
 * - No "make money" language
 * - No urgency framing
 * - No growth or leaderboard pressure
 * 
 * App Store Safe:
 * - No MLM/pyramid language
 * - Focus on appreciation credits, not income
 * - Clear that it's optional
 */

// Primary headline (used everywhere Love Links appears)
export const HEADLINE = "Share Unity Love with friends and receive ongoing appreciation.";

// One-line variant (for tight spaces)
export const HEADLINE_SHORT = "When friends you invite stay active, you receive credits as thanks.";

// Supporting explanation block
export const EXPLANATION = `Love Links lets you share Unity Love with people you trust. There's no pressure to share, no quotas, and no incentive to invite strangers.

When someone you invite becomes an active member, you receive appreciation credits as long as they remain active.`;

// How value is generated (plain-language)
export const HOW_VALUE_WORKS = {
  step1: "Invite a friend you trust",
  step2: "They join and become an active member",
  step3: "You receive appreciation credits while they're active",
  footer: "Nothing to manage or optimize. If they pause or leave, credits simply stop—no penalties.",
};

// Factual details header (de-emphasized)
export const FACTUAL_HEADER = "Credit details (for transparency)";

// Level descriptions (percentages come from config, these are labels only)
export const LEVEL_LABELS = {
  l1: {
    title: "Direct Invites (Circle 1)",
    subtitle: "Friends you directly invite who become active members.",
    description: "credit rate on their membership",
    duration: "For the duration of their active membership",
  },
  l2: {
    title: "Extended Circle (Circle 2)",
    subtitle: "Friends invited by your direct invites.",
    description: "credit rate on monthly memberships",
    duration: "For the first 12 months of their activity",
  },
};

// Share section microcopy
export const SHARE_MICROCOPY = "Share with friends you think would enjoy Unity Love.";

// CTA section
export const CTA_TITLE = "Know someone who'd like Unity Love?";
export const CTA_BODY = "Share your link and receive appreciation credits when they join.";

// Attribution notice
export const ATTRIBUTION_NOTICE = "When someone joins through your link, they're connected to your Circle permanently.";

export default {
  HEADLINE,
  HEADLINE_SHORT,
  EXPLANATION,
  HOW_VALUE_WORKS,
  FACTUAL_HEADER,
  LEVEL_LABELS,
  SHARE_MICROCOPY,
  CTA_TITLE,
  CTA_BODY,
  ATTRIBUTION_NOTICE,
};
